import { INFO_PAGES } from "@/lib/infoPages";

export default function InfoPage({ page }) {
  const info = INFO_PAGES[page];
  return (
    <div className="max-w-3xl mx-auto px-5 sm:px-8 pt-16" data-testid={`info-page-${page}`}>
      <div className="text-[11px] uppercase tracking-[0.25em] text-[#956842] mb-3">{info.eyebrow}</div>
      <h1 data-testid="info-page-title" className="font-serif text-4xl sm:text-5xl lg:text-6xl text-[#39251D] leading-none">{info.title}</h1>
      <div className="mt-12 p-8 stitch bg-[#E9DFCE]/40" data-testid="info-page-placeholder">
        <p className="font-serif text-2xl text-[#39251D]">Contenuto in preparazione</p>
        <p className="mt-3 text-sm leading-relaxed text-[#242321]/75">
          Questa pagina verrà compilata con i dati aziendali reali forniti dal titolare. Nessun contenuto è stato inventato.
        </p>
      </div>
    </div>
  );
}
